import { __assign } from "tslib";
import React, { useState } from "react";
import { Image, Linking, Platform, TouchableOpacity, View } from "react-native";
import { useSelector } from "react-redux";
import { genericStatusCheck } from "../../utils";
import { PnmacHeadline, PnmacHtmlToNative, PnmacSubheading, PnmacText, PnmacUIButton } from "pnmac-universal-components";
import GetPayoffNotAvailable from "./GetPayoffNotAvailable";
import GetPayoffStatement from "./GetPayoffStatement";
import { textStyle } from '../../v2/theme';
import { trackEvent } from '../../Tealium';
function RefiPnmacComponent(_a) {
  var translations = _a.translations,
    onPress = _a.onPress,
    showTop = _a.showTop;
  return /*#__PURE__*/React.createElement(View, null, showTop && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(PnmacHeadline, {
    style: styles.sectionHeadline
  }, translations === null || translations === void 0 ? void 0 : translations.WereThrilled), Platform.OS === "web" ? /*#__PURE__*/React.createElement(PnmacSubheading, {
    style: styles.sectionSubheader
  }, /*#__PURE__*/React.createElement(PnmacHtmlToNative, {
    value: translations === null || translations === void 0 ? void 0 : translations.WereThrilledSubheader
  })) : /*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(PnmacHtmlToNative, {
    value: translations === null || translations === void 0 ? void 0 : translations.WereThrilledSubheader
  }))), /*#__PURE__*/React.createElement(PnmacUIButton, {
    mode: 'contained',
    style: {
      marginTop: 30
    },
    onPress: onPress
  }, translations === null || translations === void 0 ? void 0 : translations.RequestPayoffStatement), /*#__PURE__*/React.createElement(PnmacSubheading, {
    style: styles.subHeader
  }, translations === null || translations === void 0 ? void 0 : translations.LearningCenter), /*#__PURE__*/React.createElement(View, {
    style: Platform.OS === "web" && {
      flexDirection: "row"
    }
  }, [{
    image: require("../../assets/the-loan-process-why-does-it-take-so-long.jpeg"),
    title: translations.UnderstandingMortgage,
    url: "https://www.pennymac.com/blog/the-loan-process-why-does-it-take-so-long"
  }, {
    image: require("../../assets/nerdwallet-credit-questions-answered.jpeg"),
    title: translations.HowCreditScore,
    url: "https://www.pennymac.com/blog/nerdwallet-credit-questions-answered"
  }, {
    image: require("../../assets/why-cash-out-refinancing-may-not-always-make-sense.jpeg"),
    title: translations.CashoutRefi,
    url: "https://www.pennymac.com/blog/why-cash-out-refinancing-may-not-always-make-sense"
  }].map(function (item, index) {
    return /*#__PURE__*/React.createElement(TouchableOpacity, {
      onPress: function () {
        return Platform.OS === "web" ? window.open(item.url, "_blank") : Linking.openURL(item.url);
      },
      style: [styles.imageView, Platform.OS === "web" && {
        flex: 1,
        marginRight: 20
      }],
      key: String(index)
    }, /*#__PURE__*/React.createElement(Image, {
      style: styles.image,
      source: item.image
    }), /*#__PURE__*/React.createElement(PnmacText, {
      style: styles.tileText
    }, item.title));
  })));
}
function RefiPnmac(_a) {
  var _b, _c;
  var translations = _a.translations,
    _d = _a.showTop,
    showTop = _d === void 0 ? false : _d,
    _e = _a.onPressStatement,
    onPressStatement = _e === void 0 ? function () {} : _e,
    payOffReason = _a.payOffReason,
    tealiumReason = _a.tealiumReason;
  var state = useSelector(function (state) {
    return state;
  });
  var status = ((_b = state === null || state === void 0 ? void 0 : state.selectedLoanAvailability) === null || _b === void 0 ? void 0 : _b.status) || {};
  var payedOff = (_c = genericStatusCheck(status, "completeOne", ["servicereleased"])) === null || _c === void 0 ? void 0 : _c.hasSubStatus;
  var _f = useState("RefinancePennyMac"),
    route = _f[0],
    setRoute = _f[1];
  switch (route) {
    case "GetPayoffNotAvailable":
      {
        return /*#__PURE__*/React.createElement(GetPayoffNotAvailable, null);
      }
    case "GetPayoffStatement":
      {
        return /*#__PURE__*/React.createElement(GetPayoffStatement, {
          translations: translations,
          payOffReason: payOffReason,
          tealiumReason: tealiumReason
        });
      }
    default:
      {
        return /*#__PURE__*/React.createElement(View, {
          style: styles.container
        }, /*#__PURE__*/React.createElement(RefiPnmacComponent, {
          showTop: showTop,
          translations: translations,
          onPress: function () {
            trackEvent('payoff_request_started', {
              'payoff_reason': tealiumReason,
              start_time: new Date()
            });
            setRoute(payedOff ? "GetPayoffNotAvailable" : "GetPayoffStatement");
            onPressStatement();
          }
        }));
      }
  }
}
var styles = {
  container: {
    margin: 10
  },
  sectionHeadline: {
    fontSize: 34
  },
  sectionSubheader: {
    color: "#707070",
    marginTop: 20
  },
  button: {
    marginTop: 30,
    alignSelf: "center",
    backgroundColor: "#F1C400"
  },
  subHeader: __assign(__assign({}, textStyle.defaultTextTitle), {
    color: "#707070",
    marginTop: 30,
    marginBottom: 10
  }),
  imageView: {
    backgroundColor: "#fff",
    shadowColor: "rgba(0,0,0, .08)",
    shadowOffset: {
      height: 4,
      width: 2
    },
    shadowOpacity: 1,
    shadowRadius: 12,
    elevation: 4,
    marginVertical: 10,
    borderRadius: 10
  },
  image: {
    height: 200,
    width: "100%",
    borderTopLeftRadius: 10,
    borderTopRightRadius: 10
  },
  tileText: __assign(__assign({}, textStyle.defaultTextDescription), {
    fontSize: 16,
    textAlign: "center",
    margin: 20
  })
};
export default RefiPnmac;